export enum DeskAreaType {
  FlexDesk = "flexDesk",
  MeetingRoom = "meetingRoom",
  Parking = "parking",
  Other = "other",
}

export enum DeskAreaViewType {
  FlexDesk = DeskAreaType.FlexDesk,
  MeetingRoom = DeskAreaType.MeetingRoom,
  Parking = DeskAreaType.Parking,
  Other = DeskAreaType.Other,
  All = "all",
}

//** Used to sort area types in a specific order for showing in the UI with that desired order */
export const deskAreaTypeOrderMap: { [key: string]: number } = {
  [DeskAreaType.FlexDesk]: 1,
  [DeskAreaType.MeetingRoom]: 2,
  [DeskAreaType.Parking]: 3,
  [DeskAreaType.Other]: 4,
};
